module.exports = __webpack_public_path__ + "img/ssl.36b134d2.svg";